import React from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Icon from "@mui/material/Icon";
import Slide from "@mui/material/Slide";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function FreeTrialBanner({ show }) {
    const navigate = useNavigate();

    if (!show) return null;

    return (
        <Slide direction="down" in={show} mountOnEnter unmountOnExit>
            <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                py={0.5}
                px={2}
                sx={{
                    background: "linear-gradient(135deg, #00A1A1 0%, #004d4d 100%)", // Comparedly Theme (Teal)
                    borderRadius: "12px",
                    boxShadow: "0 4px 20px 0 rgba(0, 161, 161, 0.3)",
                    color: "white",
                    width: "100%",
                    maxWidth: "800px",
                    margin: "0 auto",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* Glass effect overlay */}
                <MDBox
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    sx={{
                        background: "rgba(255, 255, 255, 0.1)",
                        backdropFilter: "blur(10px)",
                        zIndex: 0,
                    }}
                />

                <MDBox position="relative" zIndex={1} display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" justifyContent="space-between" width="100%" gap={2}>
                    <MDBox display="flex" alignItems="center" gap={2}>
                        <MDBox
                            bgColor="white"
                            borderRadius="lg"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width="2.5rem"
                            height="2.5rem"
                            sx={{ color: "#00A1A1" }}
                        >
                            <Icon fontSize="medium">insights</Icon>
                        </MDBox>
                        <MDBox>
                            <MDTypography variant="subtitle2" color="white" fontWeight="bold" lineHeight={1.2}>
                                Want to see this using your own brand or competitors?
                            </MDTypography>
                            <MDTypography variant="caption" color="white" opacity={0.9} lineHeight={1}>
                                Start a free trial to log in and connect profiles.
                            </MDTypography>
                        </MDBox>
                    </MDBox>

                    <MDButton
                        variant="contained"
                        color="accent"
                        size="small"
                        onClick={() => navigate("/auth/register")}
                    // sx={{ color: "#00A1A1 !important", fontWeight: "bold", minWidth: "160px" }}
                    >
                        Start Your Free Trial
                    </MDButton>
                </MDBox>
            </MDBox>
        </Slide>
    );
}

export default FreeTrialBanner;
